import utils from "../../services/utils";
import algoliasearch from "algoliasearch/lite";
import { parse } from "query-string";
import { v4 as uuid } from "uuid";
import * as localForage from "localforage";

import Visitor from "./visitor.vue";
import User from "./user.vue";
import AuthApi from "../../services/api/authApi.js";
import { mapGetters } from "vuex";
import Session from "../../services/session";
import { shopifyApi } from "../../services/api/shopifyApi";

export default {
  components: {
    Visitor,
    User,
  },
  data() {
    return {
      isUserLogged: false,
    };
  },

  methods: {
    shopNow,
    redirect,
    toBuyer() {
      this.$router.push({ path: "/wholesale-retail/buyer" });
    },
    toBrand() {
      this.$router.push({ path: "/wholesale-retail/brand" });
    },
    openRegisterModal,
  },

  mounted() {
    // RETAILER VERIFICATION
    // they have a email_verification_code (coming from signUpAsRetailer email)
    if (this.$route.query && this.$route.query.email_verification_code) {
      const AuthAPI = new AuthApi();
      const { email_verification_code } = this.$route.query;
      // run the verify retailer request
      AuthAPI.verifyRetailer({ code: email_verification_code })
        //once the verification is a success redirect
        // to the signin page
        .then(() => {
          this.$ma.trackEvent({ action: "Email Verification", properties: { Success: true } });
          this.$swal(
            "Success",
            "You have successfully verified your account. You can now login and start shopping."
          ).then(() => {
            this.$router.push("sign-in");
          });
        })
        .catch((error) => {
          this.$swal("Attention", error.response.data.error_message);
        });
    } else if (this.$route.query && this.$route.query.redirect && this.$route.query.redirect === "plus") {
      this.$swal(
        "Attention",
        "It looks like you do not have access to this feature yet. Please email support@bulletin.co if you believe you are seeing this message in error."
      );
      this.$ma.trackEvent({
        action: "Bplus invalid access attempt",
      });
    }
  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
};

function openRegisterModal() {
  this.$eventBus.$emit("apply-modal-unregistered", null);
}

function shopNow() {
  this.$eventBus.$emit("show-promo-modal");
}

function redirect(target, type) {
  if (type == "category") {
    const urlPath = `wholesale-retail/category/${utils.urlSafeString(target.name)}/${target.id}/products`;
    this.$router.push(urlPath);
  } else if (type === "collection") {
    this.$router.push("/collections/" + target + "/products");
  } else {
    this.$router.push("/value-props/" + target);
  }
}
